import { Pipe, PipeTransform } from '@angular/core';
import { getNationFromNationCode } from '../components/shared/utils';

/**
 * This pipe return the related nation name from a provided nation code
 */
@Pipe({
  name: 'nationCode',
  standalone: true
})
export class NationCodePipe implements PipeTransform {
  transform(nationCode: string | null | undefined): string {
    if (!nationCode) {
      return '';
    }
    
    const country = getNationFromNationCode(nationCode);
    return country ? country.name : nationCode; // Fallback to code if not found
  }
}